export const getCompanyPath = (companyId: string, path: string): string => {
  if (!companyId) {
    return path
  }

  if (path.startsWith(`/${companyId}/`)) {
    return path
  }

  if (path.startsWith('/spaces')) {
    return `/${companyId}${path}`
  }

  return path
}

export const withCompanyIdInRedirectUrl = (
  redirectUrl: string,
  companyId: string,
): string => getCompanyPath(companyId, redirectUrl)
